module.exports = __webpack_public_path__ + "static/img/wave-height.2944c9cc.png";